import React, { Component } from "react";
import "./createRecommendation.scss";
import ApiV2 from "../../common/apiV2";
import { Card, Form, Button, Row, Col, Container, Navbar, Nav } from "react-bootstrap";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Redirect, withRouter } from "react-router-dom";

class CreateRecommendationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxChecked: true,
      name: null,
      city: null,
      country: null,
      tags: "",
      caption: "",
      isPublic: false,
      registerClicked: false,
      successfulAdd: false
    };
  }

  redirectToProfile() {
    return (
      <Redirect to="/profile" />
    )
  }

  componentDidMount(){
    if(!this.props.selectedMarker){
      return;
    }
    this.parseMapboxSpot(this.props.selectedMarker);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevState.registerClicked === false &&
      this.state.registerClicked === true
    ) {
      try {
        await ApiV2.createRecommendation(
          this.state.name,
          this.state.city,
          this.state.country,
          this.state.isPublic,
          this.state.tags,
          this.state.caption,
          this.props.selectedMarker
        );
        this.setState({
          successfulAdd: true
        });

        this.props.notifyInfo(
          "Successfully created " + this.state.name
        );

      } catch (e) {
        console.log("Error: ", JSON.stringify(e));
        this.props.notifyFailure(
          "Failed to create recomendation. Missing info"
        );
      }
      this.setState({
        registerClicked: false
      });

      this.props.setSelectedMarker(null);
    }
  }

  onRegisterClicked = () => {
    this.setState({
      registerClicked: true
    });
  };

  parseMapboxSpot = (spot) => {
    for (let i = 0; i < spot.context.length; i++) {
      if(spot.context[i].id.startsWith("country")){
        console.log("found country at : ", i);
        this.setState({country: spot.context[i].text})
      } else if (spot.context[i].id.startsWith("place")){
        console.log("found city: ", spot.context[i].text);
        this.setState({city: spot.context[i].text})
      }
    }
    this.setState({
      name: spot.text,
    });
  }

  handleChange = () => {
    this.setState({
      checkboxChecked: (!this.state.checkboxChecked),
    });
    this.setState({
      isPublic: (this.state.checkboxChecked),
    });
  }

  renderCreateForm() {
    return (
      <Form className="my-0 pb-5">
        <Form.Group as={Row}>
          <Col md={8}>
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              value={this.state.name}
              placeholder="Recommendation name"
              onChange={event => {
                this.setState({
                  name: event.target.value
                });
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Col md={8}>
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              placeholder="City"
              value={this.state.city}
              onChange={event => {
                this.setState({
                  city: event.target.value
                });
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Col md={8}>
           <Form.Label>Country</Form.Label>
            <Form.Control
              type="text"
              placeholder="Country"
              value={this.state.country}
              onChange={event => {
                this.setState({
                  country: event.target.value
                });
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Col md={8}>
            <Form.Label>Tags</Form.Label>
            <Form.Control
              type="text"
              placeholder="Tags"
              onChange={event => {
                this.setState({
                  tags: event.target.value
                });
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-1">
          <Col md={8}>
          <Form.Label>Caption</Form.Label>
            <Form.Control
              as="textarea" rows="3"
              maxLength="280"
              placeholder="Caption (280 characters limit)"
              onChange={event => {
                this.setState({
                  caption: event.target.value
                });
              }}
              onKeyPress={e => {
                if (e.key === "Enter") {
                  this.onRegisterClicked();
                }
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Check
            type="checkbox"
            label="Make recommendation private"
            defaultChecked={this.state.checkboxChecked}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Button className="w-100" variant="primary" onClick={this.onRegisterClicked}>
          Add Recommendation
        </Button>
      </Form>
    );
  }

  render() {
    if(!this.props.selectedMarker){
      return(<Redirect to="/explore" />)
    }
    return (
      <Container className="child-container">
        <Navbar expand="lg" bg="light" variant="light" sticky="top" fixed="top" className="top-nav nav-fill">
          <Nav>
          <Nav.Link>
              <Button onClick={() => this.props.history.goBack()}>
                  <FontAwesomeIcon icon={faChevronLeft} />
              </Button>
          </Nav.Link>
          </Nav>
          <Navbar.Brand className="brand">{"Create spot"}</Navbar.Brand>
        </Navbar>
        <Row className="mt-2">
          <Col className="p-0" md={8}>
            <Card>
              <Card.Body>
                {this.state.successfulAdd
                  ? this.redirectToProfile()
                  : this.renderCreateForm()
                }
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

CreateRecommendationPage.propTypes = {
  notifyInfo: PropTypes.func.isRequired,
  notifyFailure: PropTypes.func.isRequired,
  selectMarker: PropTypes.object.isRequired,
  setSelectMarker: PropTypes.func.isRequired,
};

export default withRouter(CreateRecommendationPage);
